import { getLoadedPostHog } from './posthog-loader';

type Client = NonNullable<ReturnType<typeof getLoadedPostHog>>;

/** FIFO acotada: navegar antes de cargar el SDK no elimina la página de entrada. */
export function createPageviewQueue(
  getClient = getLoadedPostHog,
  schedule: typeof setTimeout = setTimeout,
  cancel: typeof clearTimeout = clearTimeout,
) {
  const pending: Array<(client: Client) => void> = [];
  let timer: ReturnType<typeof setTimeout> | undefined;
  let attempts = 0;
  let disposed = false;
  const drain = () => {
    timer = undefined;
    if (disposed) return;
    const client = getClient();
    if (client?.__loaded) {
      while (pending.length) pending.shift()!(client);
      attempts = 0;
    } else if (++attempts <= 64) {
      timer = schedule(drain, 250);
    } else {
      pending.length = 0;
    }
  };
  return {
    enqueue(capture: (client: Client) => void) {
      if (disposed) return;
      if (pending.length >= 64) return;
      pending.push(capture);
      if (!timer) { attempts = 0; drain(); }
    },
    dispose() {
      disposed = true;
      if (timer) cancel(timer);
      pending.length = 0;
    },
  };
}
